<div class="row footer_sec">
    <div class="col-md-4 col-lg-4 footer_img">
        
    </div>
    <div class="col-md-4 col-lg-4 timestamp">
        Current date & time : {{ now | date:'EEEE, MMMM d, y &nbsp; HH:mm:ss'}} &nbsp;
    </div>
    <div class="col-md-4 col-lg-4 footer_content">
        <p class="footer_right_txt">
            &#169; LTIMindtree NxT. All rights reserved.
        </p>
        <div class="powered-by">
            <p class="text">Powered By</p>        
            <img src="assets/images/Menu_Icons/Mines_NxT_Logo.svg" class="avatar" alt="Avatar">
    
        </div>
        
    </div>
</div>